import { Observable } from 'rxjs';
import { LocationValue } from './location';
import { DeviceValue } from "./device";

export interface AlarmValue {
  code: number;
  msg: string;
}

export interface AutomationControllerValue {
  dt: string;
  Uab: number; 
  Ubc: number; 
  Uca: number; 
  _3U0: number; 
  U2: number; 
  Ua: number; 
  Ub: number; 
  Uc: number;
  alarm: AlarmValue;
}

export interface ControllerConnectionValue {
  virtualComPath: string;
  baudRate: number;
  modbusDeviceId: number;
}

export interface AutomationValue {
  location: LocationValue;
  device: DeviceValue;
  connection: ControllerConnectionValue;
  value: AutomationControllerValue;
}

// export interface ActivePowerValue {
//   dt: string;
//   Pac: number;
// }

export abstract class AutomationData {
  abstract getAutomationControllerData(sn: string): Observable<AutomationValue[]>;
  // abstract getData(sn: string): Observable<AutomationValue[]>;
}

/*
{ 
  "_id" : ObjectId("5e8dc4e976a280c2f475932f"), 
  "location" : {
      "name" : "zaichevskoe", 
      "soling" : NumberInt(2), 
      "ktp" : NumberInt(1)
  }, 
  "device" : {
      "category" : "high", 
      "type" : "controller", 
      "num" : NumberInt(1), 
      "sn" : "00080619", 
      "manufacturer" : "РЗА СИСТЕМЗ", 
      "model" : "PC83-AB2"
  }, 
  "connection" : {
      "virtualComPath" : "/tmp/virtualcom0", 
      "baudRate" : NumberInt(19200), 
      "modbusDeviceId" : NumberInt(1)
  }, 
  "descrete_input_devices" : [

  ], 
  "value" : {
      "Uab" : 103.73, 
      "Ubc" : 101.53, 
      "Uca" : 103.99, 
      "3U0" : 0.62, 
      "U2" : 1.55, 
      "Ua" : 60.58, 
      "Ub" : 58.8, 
      "Uc" : 59.17, 
      "alarm" : {
          "0" : "no-alarm"
      }, 
      "dt" : "2020-04-09T09:01:43.399Z"
  }
}
*/